import { Draft, PayloadAction } from '@reduxjs/toolkit';

export const OPERATION_STARTED = 'operationStarted';
export const OPERATION_FINISHED = 'operationFinished';

export interface ActionMeta {
  [OPERATION_STARTED]?: boolean;
  [OPERATION_FINISHED]?: boolean;
  request?: any;
}

type IsExactlyAny<T, Y, N> = boolean extends (T extends never ? true : false)
  ? Y
  : N;

export const emptyAction =
  <T>() =>
  (_state: unknown, _action: PayloadAction<IsExactlyAny<T, void, T>>): void => {
    // not implemented
  };

export const pendingAction = <S = unknown, T = void>(
  reducer: (state: Draft<S>, action: PayloadAction<T>) => void = (): void => {
    // not implemented
  }
) => ({
  reducer,
  prepare: (payload: IsExactlyAny<T, void, T>) => ({
    payload,
    meta: { [OPERATION_STARTED]: true },
  }),
});

export const successAction = <S = unknown, T = void>(
  reducer: (state: Draft<S>, action: PayloadAction<T>) => void = (): void => {
    // not implemented
  }
) => ({
  reducer,
  prepare: (payload: IsExactlyAny<T, void, T>) => ({
    payload,
    meta: { [OPERATION_FINISHED]: true },
  }),
});

export const failureAction = <S = unknown, T extends Error = Error>(
  reducer: (state: Draft<S>, action: PayloadAction<T>) => void = (): void => {
    // not implemented
  }
) => ({
  reducer,
  prepare: (payload: IsExactlyAny<T, Error, T>) => ({
    payload,
    error: true as const,
    meta: { [OPERATION_FINISHED]: true },
  }),
});
